/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
   {
      _id: "j5-yKhDd64s",
      title: "Eminem - Not Afraid",
      videoLength: "4:18",
      likes: "10M",
      views: "1.6B",
      date: "5th June, 2010",
      category: "rap music",
      featured: true,
      channelName: "EminemMusic",
      channelThumbnail:
         "https://yt3.ggpht.com/ytc/AKedOLTl3oEyE5erZSJL6T3AqzFUo2pjsbI2f595a8gvQQ=s48-c-k-c0x00ffffff-no-rj-mo",
      subscribers: "51.8M",
      description:
         "Music video by Eminem performing Not Afraid. (C) 2010 Aftermath Records",
   },
   {
      _id: "Obim8BYGnOE",
      title: "Till I Collapse",
      videoLength: "4:57",
      likes: "1.6M",
      views: "195M",
      date: "30 Jul, 2018",
      category: "rap music",
      featured: true,
      channelName: "EminemMusic",
      channelThumbnail:
         "https://yt3.ggpht.com/ytc/AKedOLTl3oEyE5erZSJL6T3AqzFUo2pjsbI2f595a8gvQQ=s48-c-k-c0x00ffffff-no-rj-mo",
      subscribers: "51.8M",
      description:
         "Provided to YouTube by Universal Music Group 'Till I Collapse · Eminem · Nate Dogg The Eminem Show ℗ 2002 Aftermath Entertainment/Interscope Records",
   },
   {
      _id: "3beb3HXqCms",
      title: "Seedhe Maut - Nanchaku",
      videoLength: "3:17",
      likes: "335K",
      views: "11.3M",
      date: "23 Jul, 2021",
      category: "desi hiphop",
      featured: false,
      channelName: "Seedhe Maut",
      channelThumbnail:
         "https://yt3.ggpht.com/ytc/AKedOLRlwJSk1xNYX8HXfadLEWm8eqDB3KWcL1fZ17E=s48-c-k-c0x00ffffff-no-rj-mo",
      subscribers: "238K",
      description:
         "Azadi Records is proud to present - NANCHAKU. Built upon a wonky, off-kilter production by Calm that delivers a brand new aesthetic to Indian hip-hop's sonic palette, 'Nanchaku' sees Seedhe Maut and MC Stan flex their creative juices on one of the most anticipated collaboration's to hit the Indian scene till date.",
   },
   {
      _id: "1arz9Q9qBas",
      title: "Lucky You",
      videoLength: "4:05",
      likes: "1M",
      views: "120M",
      date: "31 Aug, 2018",
      category: "rap music",
      featured: false,
      channelName: "EminemMusic",
      channelThumbnail:
         "https://yt3.ggpht.com/ytc/AKedOLTl3oEyE5erZSJL6T3AqzFUo2pjsbI2f595a8gvQQ=s48-c-k-c0x00ffffff-no-rj-mo",
      subscribers: "51.8M",
      description: "From the album Kamikaze, out now: http://shady.sr/Kamikaze",
   },
   {
      _id: "v_lhTroODLQ",
      title: "NaPoM | Bass Electro",
      videoLength: "4:13",
      likes: "139K",
      views: "4.6M",
      date: "15 Sept, 2018",
      category: "beatboxing",
      featured: false,
      channelName: "Swissbeatbox",
      channelThumbnail:
         "https://yt3.ggpht.com/rNk0tujpg61lxRZncprN9nHlZ0ExmVZcdd3Cjb7ko-vXqzdMoFuqNAgUIi_t1GijdBHvRMcRvw=s48-c-k-c0x00ffffff-no-rj",
      subscribers: "4.57M",
      description:
         "Check the next video of NaPoM's Album with the routine: Bass Electro Check out NaPoM's Album Lips - You can get it here: http://swissbeatbox.com/napom_lips",
   },
   {
      _id: "lxRwEPvL-mQ",
      title: "NF - When I Grow Up",
      videoLength: "4:00",
      likes: "3.2M",
      views: "185M",
      date: "27 Jun, 2019",
      category: "rap music",
      featured: true,
      channelName: "NFrealmusic",
      channelThumbnail:
         "https://yt3.ggpht.com/ytc/AKedOLQnXWb9ENiYfpma4wii7q0KbqSYpRBXrgPWMED4Fg=s48-c-k-c0x00ffffff-no-rj-mo",
      subscribers: "8.27M",
      description:
         "Official music video for “When I Grow Up” by NF. Get the song on The Search album here: https://nf.lnk.to/thesearchYD Subscribe to NFrealmusic on YouTube: https://nf.lnk.to/youtubeID",
   },
   {
      _id: "YYKMoZnuTJE",
      title: "NaPoM | Roll Like This",
      videoLength: "3:17",
      likes: "376K",
      views: "19M",
      date: "1 Mar, 2018",
      category: "beatboxing",
      featured: true,
      channelName: "Swissbeatbox",
      channelThumbnail:
         "https://yt3.ggpht.com/rNk0tujpg61lxRZncprN9nHlZ0ExmVZcdd3Cjb7ko-vXqzdMoFuqNAgUIi_t1GijdBHvRMcRvw=s48-c-k-c0x00ffffff-no-rj",
      subscribers: "4.57M",
      description:
         "NaPoM's album Lips is finally here guys. You can get it now: http://swissbeatbox.com/napom_lips Check out this first Single video with one of our favorite routines: Roll like this.",
   },
   {
      _id: "DFk6aVSWo7s",
      title: "D-LOW | Compilation",
      videoLength: "14:25",
      likes: "262K",
      views: "16.8M",
      date: "14 May, 2019",
      category: "beatboxing",
      featured: false,
      channelName: "Swissbeatbox",
      channelThumbnail:
         "https://yt3.ggpht.com/rNk0tujpg61lxRZncprN9nHlZ0ExmVZcdd3Cjb7ko-vXqzdMoFuqNAgUIi_t1GijdBHvRMcRvw=s48-c-k-c0x00ffffff-no-rj",
      subscribers: "4.57M",
      description:
         "All rounds of D-low at the Grand Beatbox SHOWCASE Battle 2019 in an epic beatbox compilation. Congratulations again for winning this year, you really deserved it!",
   },
   {
      _id: "XGGWhOUYObc",
      title: "NF - Leave Me Alone",
      videoLength: "5:12",
      likes: "1.4M",
      views: "96M",
      date: "26 Jun, 2019",
      category: "rap music",
      featured: false,
      channelName: "NFrealmusic",
      channelThumbnail:
         "https://yt3.ggpht.com/ytc/AKedOLQnXWb9ENiYfpma4wii7q0KbqSYpRBXrgPWMED4Fg=s48-c-k-c0x00ffffff-no-rj-mo",
      subscribers: "8.27M",
      description:
         "Official music video for “Leave Me Alone” by NF. Get the song on The Search album here: https://nf.lnk.to/thesearchYD Subscribe to NFrealmusic on YouTube: https://nf.lnk.to/youtubeID",
   },
   {
      _id: "_6oY3sIegV8",
      title: "BEST of 2021 in Dance",
      videoLength: "15:25",
      likes: "6K",
      views: "494K",
      date: "5 Jan, 2022",
      category: "bboying",
      featured: false,
      channelName: "stance",
      channelThumbnail:
         "https://yt3.ggpht.com/ytc/AKedOLQFJCD1H-DfG96K2VuEHZWmL1JnwT6Z2y4L3h1O=s48-c-k-c0x00ffffff-no-rj",
      subscribers: "395K",
      description:
         "Some of our favorite dance moments from 2021 from our cameras; because of music copyright, we did not include any open styles content.",
   },
   {
      _id: "sNLkY3C5bV0",
      title: "NEGUIN vs KRISS",
      videoLength: "3:54",
      likes: "122K",
      views: "9.8M",
      date: "11 Oct, 2019",
      category: "bboying",
      featured: false,
      channelName: "stance",
      channelThumbnail:
         "https://yt3.ggpht.com/ytc/AKedOLQFJCD1H-DfG96K2VuEHZWmL1JnwT6Z2y4L3h1O=s48-c-k-c0x00ffffff-no-rj",
      subscribers: "395K",
      description:
         "Some of our favorite dance moments from NEGUIN vs KRISS 2019 from our cameras; because of music copyright, we did not include any open styles content.",
   },
   {
      _id: "jIQ0Dx-4peE",
      title: "GUMAAN - YS",
      videoLength: "4:31",
      likes: "471K",
      views: "21M",
      date: "18 Sept, 2020",
      category: "desi hiphop",
      featured: true,
      channelName: "Young Stunners",
      channelThumbnail:
         "https://yt3.ggpht.com/MtPidrxKSBIvvGdB9tAJPAX_ErcXhg8jExQr4OiVwy3JUaNPnpc3Yb57JpjXLjQR4bap2lFc2g=s48-c-k-c0x00ffffff-no-nd-rj",
      subscribers: "1.02M",
      description: "Official Video from the EP - A Tale Of Two Talhas",
   },
   {
      _id: "ijE2MMtzkHg",
      title: "AFSANAY - YS",
      videoLength: "6:29",
      likes: "386K",
      views: "16.8M",
      date: "19 Mar, 2021",
      category: "desi hiphop",
      featured: false,
      channelName: "Young Stunners",
      channelThumbnail:
         "https://yt3.ggpht.com/MtPidrxKSBIvvGdB9tAJPAX_ErcXhg8jExQr4OiVwy3JUaNPnpc3Yb57JpjXLjQR4bap2lFc2g=s48-c-k-c0x00ffffff-no-nd-rj",
      subscribers: "1.02M",
      description: "Official Video from the EP - A Tale Of Two Talhas",
   },
   {
      _id: "_CL6n0FJZpk",
      title: "Dr. Dre - Still D.R.E.",
      videoLength: "4:50",
      likes: "8.3M",
      views: "1B",
      date: "27 Oct, 2011",
      category: "old school",
      featured: false,
      channelName: "Dr Dre",
      channelThumbnail:
         "https://yt3.ggpht.com/ytc/AKedOLTTUxQNw6HTP9Arubl0159Nm4mB02Tf42utJvh0=s48-c-k-c0x00ffffff-no-rj-mo",
      subscribers: "5.74M",
      description:
         "REMASTERED IN HD!! CELEBRATING ONE BILLION VIEWS! Official Music Video for Still D.R.E. performed by Dr. Dre ft. Snoop Dogg. ",
   },
   {
      _id: "5DClBfElCLw",
      title: "Ahmer x Ikka - 'Kartab'",
      videoLength: "3:04",
      likes: "20K",
      views: "162K",
      date: "2 May, 2022",
      category: "desi hiphop",
      featured: false,
      channelName: "Ahmer",
      channelThumbnail:
         "https://yt3.ggpht.com/Om1i9jiUOs02ey2A_ye3QB9A35Tw0pdLPmnot2gqS8xW6swg6yQ3WqqA6pynSqjimQHt0uDxJw=s48-c-k-c0x00ffffff-no-nd-rj",
      subscribers: "17.9K",
      description:
         "In the build-up to Ahmer's much-anticipated sophomore full-length project, the Srinagar-based hip-hop artist teams up with one of India's biggest MCs IKKA to deliver an earworm that's destined to dominate airwaves for years to come.",
   },
   {
      _id: "QZXc39hT8t4",
      title: "Dr. Dre - The Next Episode",
      videoLength: "3:17",
      likes: "4.9M",
      views: "547M",
      date: "17 Jun, 2009",
      category: "old school",
      featured: false,
      channelName: "Dr Dre",
      channelThumbnail:
         "https://yt3.ggpht.com/ytc/AKedOLTTUxQNw6HTP9Arubl0159Nm4mB02Tf42utJvh0=s48-c-k-c0x00ffffff-no-rj-mo",
      subscribers: "5.74M",
      description:
         "REMASTERED IN HD! Official Music Video for The Next Episode performed by Dr. Dre ft. Snoop Dogg, Kurupt, and Nate Dogg.",
   },
];
